import {
  getCardStyles,
  getStringMultilocale,
} from '@quno/onboarding/src/generator/configs/componentMapper';
import {
  defaultLocale,
  localeMapper,
} from '@quno/onboarding/src/constants/locales';
import { useTranslation } from '@quno/patient-journey/src/hooks/useTranslation';
import { Accordion } from '@quno/patient-journey/src/components/Accordion/Accordion';
import { AccordionItem } from '@quno/patient-journey/src/components/Accordion/AccordionItem';
import { Base } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Base';
import { FaqJsonSchema } from '@quno/patient-journey/src/components/Accordion/FaqJsonSchema';
import type { FormLocales } from '@quno/patient-journey/src/constants/locales';
import type { Faq as FaqType } from '@quno/patient-journey/types/Utilities';
import type { FaqContainer } from '@quno/onboarding/src/generator/types/Models';

type FaqProps = FaqContainer & {
  locale: FormLocales;
};

export const Faq = (props: FaqProps): JSX.Element => {
  const { locale: pageLocale } = useTranslation();
  const locale = props.locale || localeMapper[pageLocale] || defaultLocale;
  const { attributes } = props ?? {};
  const cardStyles = getCardStyles(props);
  const faqCards = attributes?.faqCards?.[defaultLocale];

  const itemsCollection = (faqCards ?? [])?.map((faqCard) => {
    return {
      question: getStringMultilocale(faqCard?.attributes?.question, locale),
      answer: getStringMultilocale(faqCard?.attributes?.answer, locale),
    };
  }) as FaqType[];

  return (
    <Base {...props}>
      <FaqJsonSchema items={itemsCollection} />
      <Accordion>
        {faqCards?.map((faqCard, index) => {
          const { attributes } = faqCard ?? {};
          const question = getStringMultilocale(attributes?.question, locale);

          return (
            <AccordionItem
              key={index}
              title={question}
              content={attributes?.answer}
              locale={locale}
              backgroundColorOverwrite={cardStyles?.card?.backgroundColor}
              fontColorOverride={cardStyles?.card?.fontColor}
            />
          );
        })}
      </Accordion>
    </Base>
  );
};
